import React from "react";
import { Link } from "react-router-dom";


const DetailsComponent = ({ jobData, onApply }) => {
  return (
    <div className="mx-auto overflow-hidden px-4 sm:px-6 md:px-8 py-6">
      {jobData && (
        <>
          <header className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 space-y-2 md:space-y-0">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">
                {jobData?.title}
              </h1>
              <p className="text-gray-600 text-sm md:text-base">
                {jobData?.location}
              </p>
            </div>
            <p className="text-white bg-[#ff9906] text-sm md:text-base px-4 py-2 rounded-sm shadow-lg cursor-pointer">
              Job ID: {jobData?._id}
            </p>
          </header>

          <section className="p-4 border-b border-[#ff9906]">
            <h2 className="text-xl md:text-2xl font-semibold">Description:</h2>
            <p className="text-gray-700 text-sm md:text-base">
              {jobData?.description}
            </p>
          </section>

          <section className="p-4 border-b border-[#ff9906]">
            <h2 className="text-xl md:text-2xl font-semibold">
              Responsibilities:
            </h2>
            <ul className="list-disc ml-6 space-y-2 text-gray-700 text-sm md:text-base">
              {(jobData?.responsibilities || []).length === 0 && (
                <li className="text-muted-foreground">No responsibilities listed.</li>
              )}
              {(jobData?.responsibilities || []).map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="bg-[#ff9906] h-2 w-2 mt-2 rounded-full flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="p-4 border-b border-[#ff9906]">
            <h2 className="text-xl md:text-2xl font-semibold">Requirements:</h2>
            <ul className="list-disc ml-6 space-y-2 text-gray-700 text-sm md:text-base">
              {(jobData?.requirements || []).length === 0 && (
                <li className="text-muted-foreground">No requirements listed.</li>
              )}
              {(jobData?.requirements || []).map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="bg-[#ff9906] h-2 w-2 mt-2 rounded-full flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>
          <footer className="p-4 space-y-2 text-sm md:text-base">
            <h2 className="text-xl md:text-2xl font-semibold">
              Company Information:
            </h2>
            <p className="text-gray-600 ml-6">{jobData?.companyInfo}</p>
            {jobData?.hasTest ? (
              <Link to={`/job-details/apply/${jobData?._id}`}>
                <button className="bg-[#ff9906] text-white mt-2 px-4 py-2 rounded w-full sm:w-auto hover:bg-[#ff9906]">
                  Apply Now
                </button>
              </Link>
            ) : (
              <p className="mt-2 text-sm text-gray-500 italic">
                For application read the details.
              </p>
            )}
          </footer>
        </>
      )}
      {!jobData && <p>Loading or no job data available</p>}
    </div>
  );
};

export default DetailsComponent;
